/**
 * 成約済み物件一覧：エリア・種別・並び順のセレクト変更で絞り込みを反映する
 */
const soldIndex = () => {
    if (!document.body || document.body.id !== "page-sold-index") {
        return;
    }

    const selects = document.querySelectorAll("[data-sold-filter] select");
    if (!selects.length) {
        return;
    }

    selects.forEach((select) => {
        select.addEventListener("change", () => {
            const url = new URL(window.location.href);
            const name = select.getAttribute("name");
            if (!name) {
                return;
            }
            if (select.value) {
                url.searchParams.set(name, select.value);
            } else {
                url.searchParams.delete(name);
            }
            // 条件変更時は1ページ目に戻す
            url.searchParams.delete("page");
            window.location.href = url.toString();
        });
    });
};

export default soldIndex;
